<template>
	<div class="news_detail">
		<div class="ndt_pc" v-if="!isPhone">
			<div class="nd_con">
				<p class="nd_tit">{{ detail.title }}</p>
				<div class="nd_time">
					<span>更新时间：{{ detail.publishtime }}</span>
					<span>来源：{{ detail.source }}</span>
				</div>
				<div class="nd_html" v-html="detail.details"></div>
				<div class="share_box">
					<span>分享到：</span>
					<div class="sh_img1">
						<img @click="toShare(1)" src="@/images/news/icon_kj.png" />
					</div>
					<div class="sh_img1">
						<img @click="toShare(2)" src="@/images/news/icon_wb.png" />
					</div>
					<div class="sh_img2">
						<img class="wx_icon" src="@/images/news/icon_wx.png" />
						<div class="wx_code">
							<h4>微信扫一扫：分享</h4>
							<img :src="shcode" />
						</div>
					</div>
				</div>
				<div class="shangxia">
					<p @click="previousArticle">
						上一篇：{{
                        detail.uptitle ? detail.uptitle : "已经是第一篇了"
                    }}
					</p>
					<p @click="nextArticle">
						下一篇：{{
                        detail.nexttitle ? detail.nexttitle : "已经是最后一篇了"
                    }}
					</p>
				</div>
			</div>
			<div class="record_box">
				<record></record>
			</div>
		</div>
		<div class="ndt_phone" v-if="isPhone">
			<Header2 :searchShow="false" :meauShow="false" pageTitle="新闻详情"></Header2>
			<div class="nd_box">
				<p class="nd_tit">{{ detail.title }}</p>
				<div class="nd_time">
					<span>更新时间：{{ detail.publishtime }}</span>
					<span>来源：{{ detail.source }}</span>
				</div>
			</div>
			<div class="nd_html" v-html="detail.details"></div>
			<div class="shangxia">
				<p @click="previousArticle">{{detail.uptitle ? '上一篇' : "已是第一篇"}}
				</p>
				<p @click="nextArticle"> {{detail.nexttitle ? '下一篇' : "已是最后一篇"}} </p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			xid: "",
			typeid: "",
			detail: {},
			pian1: {}, //上一篇id
			pian2: {}, //下一篇id
			isPhone: this.$isMobile,
            shcode:'',
		};
	},
	created() {
		this.xid = this.$route.query.xid;
		this.typeid = this.$route.query.typeid;
		this.newsdt();
        this.getShareCode();
	},
	methods: {
		// 新闻详情
		async newsdt() {
			const res = await this.$api.newsdt({
				id: this.xid,
				typeid: this.typeid,
			});
			if (res.code == 1) {
				this.detail = res.data;
				this.upbook(1);
				this.upbook(2);
			}
		},
        async getShareCode(){
            const res = await this.$api.phpcodes({
				id: this.xid,
				typeid: this.typeid,
			});
			this.shcode = res.urls;
        },
		toShare(a) {
			if (a == 1) {
				window.open(
					"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=https%3A%2F%2Fwww.jnc.cn%2Fnews%2FnewsDetails%3Fid%3D193&title=%E5%89%91%E5%8D%97%E6%98%A5%E9%9B%86%E5%9B%A2%E5%85%AC%E5%8F%B8&desc=&summary=&site=%E5%89%91%E5%8D%97%E6%98%A5%E9%9B%86%E5%9B%A2%E5%85%AC%E5%8F%B8",
					"_blank"
				);
			}
			if (a == 2) {
				window.open(
					"https://service.weibo.com/share/share.php?url=https://www.jnc.cn/news/newsDetails?id=193&title=%E5%89%91%E5%8D%97%E6%98%A5%E9%9B%86%E5%9B%A2%E5%85%AC%E5%8F%B8&pic=",
					"_blank"
				);
			}
		},
		async upbook(st) {
			var data5 = {
				status: st,
				id: this.xid,
				typeid: this.typeid,
			}
			const res = await this.$api.upnextbook(data5);
			if (st == 1) {
				if (res.code == 1 && res.data != null) {
					this.pian1 = res.data;
				} else {
					this.pian1 = {};
				}
			}
			if (st == 2) {

				if (res.code == 1 && res.data != null) {
					this.pian2 = res.data;
				} else {
					this.pian2 = {};
				}
			}
		},
		previousArticle() {
			if (this.pian1.id) {
				this.xid = this.pian1.id;
				this.newsdt();
                this.getShareCode();
			}
		},
		nextArticle() {
			if (this.pian2.id) {
				this.xid = this.pian2.id;
				this.newsdt();
                this.getShareCode();
			}
		},
	},
};
</script>

<style lang="scss">
.news_detail {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.ndt_pc {
		margin-top: 76px;
		width: 100%;
		padding: 64px 0 80px;
		min-height: 1000px;
		background-image: url("../../images/bgimg3.png");
		box-sizing: border-box;
		.nd_con {
			max-width: 1040px;
			margin: 0 auto;
			padding: 0 20px;
			.nd_tit {
				color: #000;
				font-size: 36px;
				margin-bottom: 24px;
				text-align: left;
			}
			.nd_time {
				color: #666;
				font-size: 16px;
				padding-bottom: 28px;
				border-bottom: 1px solid #e4d9c6;
				margin-bottom: 30px;
				text-align: left;
				span {
					display: inline-block;
					margin-right: 15px;
				}
			}
			.nd_html {
				p {
					text-align: left;
				}
                img{
                    max-width: 100% !important;
                }
			}
			.share_box {
				display: flex;
				align-items: center;
				padding-bottom: 2px;
				border-bottom: 1px solid #e4d9c6;
				.sh_img1 {
					img {
						width: 32px;
						height: 32px;
						margin-right: 10px;
						cursor: pointer;
					}
				}
				.sh_img2 {
					position: relative;
					.wx_icon {
						width: 32px;
						height: 32px;
						cursor: pointer;
					}
					&:hover {
						.wx_code {
							display: block;
						}
					}
					.wx_code {
						display: none;
						border: 1px solid #eee;
						position: absolute;
						z-index: 9;
						top: -205px;
						left: -84px;
						width: 200px;
						height: 192px;
						color: #666;
						font-size: 12px;
						text-align: center;
						background-color: #fff;
						box-shadow: 0 2px 10px #aaa;
						transition: all 200ms;
						h4 {
							padding: 4px 0;
							background-color: #f3f3f3;
						}
						img {
						}
					}
				}
			}
			.shangxia {
				padding-top: 38px;
				p {
					color: #999;
					font-size: 16px;
					display: block;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					margin-bottom: 12px;
					text-align: left;
					cursor: pointer;
					&:hover {
						color: #cc0000;
					}
				}
			}
		}
		.record_box {
			margin-top: 80px;
		}
	}
	.ndt_phone {
		background-image: url("../../images/bgimg3.png");
		padding: 1.3rem 0 2.5rem 0;
		min-height: 90vh;
		.nd_box {
			padding: 0.47rem 0.51rem;
			border-bottom: 1px solid #dfdfdf;
			.nd_tit {
				color: #333;
				font-size: 17px;
				line-height: 1.8;
				margin-bottom: 0.15rem;
				text-align: left;
			}
			.nd_time {
				text-align: left;
				span {
					display: inline-block;
					margin-right: 0.48rem;
					font-size: 14px;
					color: #999;
				}
			}
		}
		.nd_html {
			color: #333;
			font-size: 15px;
			line-height: 1.7;
			padding: 0.53rem;
			p {
				text-align: left;
			}
			img {
				max-width: 100% !important;
			}
		}
		.shangxia {
			display: flex;
			padding: 0.53rem;
			p {
				display: inline-block;
				color: #fff;
				border: 1px solid #d43235;
				background-color: #d43235;
				height: 1.17rem;
				line-height: 1.17rem;
				text-align: center;
				border-radius: 3px;
				flex: 1;
				font-size: 16px;
				margin-left: 0.53rem;
			}
		}
	}
}
</style>